import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';
import { DeveloperCellDesktop } from './DeveloperCellDesktop';
import { DeveloperCellMobile } from './DeveloperCellMobile';

export interface IDeveloperCellProps {
  cell: IDeveloperCell;
}

export const DeveloperCell = ({ cell }: IDeveloperCellProps): React.JSX.Element => (
  <>
    <Responsive phone tablet>
      <DeveloperCellMobile cell={cell} />
    </Responsive>
    <Responsive desktop>
      <DeveloperCellDesktop cell={cell} />
    </Responsive>
  </>
);
